import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import {
  Grid,
  Box,
  Collapse,
  CircularProgress,
  InputAdornment,
  Modal,
  Typography
} from "@mui/material";
import * as Yup from "yup";
import { Formik, Form, FastField } from "formik";
import { Close, Save, Search } from "@mui/icons-material";
import { isEmpty } from "lodash";
import Api from "../../../api2";
import Helper from "../../../helpers";
import {
  MyBreadCrumbs,
  MyTable,
  MyForm,
  MyTextField,
  MySelect,
  MyButton,
  MyThaoTac,
  MySelectTime,
  UploadMultiFile,
  PopConfirm,
  MySelectButton,
  MyWrapperModal,
  ThongBao,
  HQModalHotAdd,
  HQCollapseForm,
  DisplayFormikState,
  MySearchBox,
  MyMultiSelect
} from "../Components";
import Api_DanhMuc from "../../../api_danhmuc";
import { MyTextFieldArea } from "../../Lib/componentLibrarys";
export default function DM_ThuocTruSau({ group, ...props }) {
  const [TBdata, setTBData] = useState([]);
  const [dataFormik, setDataFormik] = useState({
    tuKhoa: "",
    limit: 10,
    anchor: 0
  });
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();

  const [Loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [SearchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const formikRef = useRef();

  useEffect(() => {
    const values = formikRef.current.values;
    getApi(values);
  }, []);

  const getRows = (limit, anchor, page) => {
    const values = formikRef.current.values;
    getApi({ ...values, limit, anchor, page });
  };
  const getApi = ({ tukhoa, limit, anchor, page, ...rest }) => {
    setLoading(true);
    const data = { tukhoa, limit, anchor, ...rest };

    new Api_DanhMuc()
      .GetListThuocTruSaus({ data })
      .then(res => {
        if (res.code === 200) {
          setTBData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
          if (res.data?.count) {
            setCount(res.data?.count);
          }
        } else {
          ThongBao({ code: res.code });
        }
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        ThongBao({ status: "error", message: "Có lỗi xảy ra, xem log!" });
        console.log(err);
      });
  };
  // Open form
  const handleAdd = () => {
    setOpenModal(true);
  };
  const handleEdit = params => {
    setOpenModal(params?.id || undefined);
  };
  // Submit form add or edit
  const handleSubmit = values => {
    new Api_DanhMuc()
      .UpsertThuocTruSau({ data: values })
      .then(res => {
        if (res.code === 200) {
          ThongBao({ status: "success", message: "Lưu thành công!" });
          setOpenModal(false);
          const values = formikRef.current.values;
          getApi(values);
        } else {
          ThongBao({ code: res.code });
        }
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Có lỗi xảy ra, xem log!" });
        console.log(err);
      });
  };
  const handleDelete = params => {
    new Api_DanhMuc()
      .DeleteThuocTruSau({ id: params?.id || null })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(values);
          ThongBao({ status: "success", message: "Xóa thành công" });
        } else {
          ThongBao({ code: res.code });
        }
      })
      .catch(err => {
        ThongBao({ status: "error", message: `Có lỗi xảy ra, xem log!` });
        console.log("Lỗi:", err);
      });
  };
  return (
    <div>
      <MyBreadCrumbs
        title={[
          { name: "Vận hành" },
          { name: "Danh mục" },
          { name: "Danh mục dùng chung" },
          { name: "Thuốc trừ sâu" }
        ]}
      />
      <MySearchBox
        name="tuKhoa"
        formikRef={formikRef}
        showState={false}
        initialValues={dataFormik}
        onSubmit={values => {
          getApi(values);
        }}
        customButton={[
          {
            title: "Thêm mới",
            action: () => {
              handleAdd();
            }
          }
        ]}
      ></MySearchBox>
      <CreateModal
        open={openModal}
        handleClose={setOpenModal}
        onSubmit={handleSubmit}
        title={
          typeof openModal === "boolean" && openModal ? "Thêm" : "Cập nhật"
        }
        width="40vw"
      />
      <MyTable
        autofit={false}
        columns={[
          {
            headerName: "STT",
            field: "stt",
            width: "100px",
            suppressSizeToFit: true,
            pinned: "left",
            headerClass: "ag-grid-header-center",
            cellStyle: { justifyContent: "center" }
          },
          {
            field: "tenThuoc",
            headerName: "Tên thuốc",
            width: "300px"
          },
          {
            field: "tacDung",
            headerName: "Tác dụng",
            minWidth: 300,
            flex: 1
          },
          {
            headerName: "Thao tác",
            width: "100px",
            suppressSizeToFit: true,
            pinned: "right",
            cellRendererFramework: prams => (
              <MyThaoTac
                prams={prams}
                handleDelete={handleDelete}
                handleEdit={handleEdit}
              />
            )
          }
        ]}
        data={TBdata}
        loading={Loading}
        pagination={{
          rawData: rawData,
          getRows: getRows,
          setData: setTBData,
          Count: Count
        }}
      />
    </div>
  );
}
function CreateModal({
  title,
  handleClose,
  onSubmit,
  open,
  style,
  dataSet,
  width = "40vw",
  ...props
}) {
  const [inititalValue, setInitialValue] = useState(null);
  const formRef = React.useRef(null);
  const validateSchema = Yup.object().shape({
    tenThuoc: Yup.string().required("Không được để trống")
  });
  useEffect(() => {
    const fetchData = async () => {
      if (typeof open !== "boolean" && Boolean(open)) {
        new Api_DanhMuc()
          .GetThuocTruSau({ id: open })
          .then(res => {
            if (res.code === 200) {
              setInitialValue(res.data);
            } else {
              ThongBao({ code: res.code });
            }
          })
          .catch(err => {
            ThongBao({ status: "error", message: `Có lỗi xảy ra, xem log!` });
            console.log("Lỗi:", err);
          });
      } else {
        setInitialValue({});
      }
    };

    fetchData();
  }, [open]);
  return (
    <Modal
      open={Boolean(open)}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose(false);
        }
      }}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box
        sx={{
          width: width,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          borderRadius: 1,
          padding: 2,
          ...style
        }}
      >
        <Typography
          variant="h6"
          fontWeight={"bold"}
          gutterBottom
          display="flex"
          justifyContent="space-between"
        >
          {title || "Tiêu đề Modal"}
          <Close
            onClick={() => handleClose(false)}
            sx={{ cursor: "pointer", "&:hover": { opacity: "0.5" } }}
          />
        </Typography>
        <Grid
          container
          width="100%"
          spacing={1}
          direction="column"
          margin={0}
          className="hq_modal_child_content"
        >
          <Formik
            onSubmit={onSubmit}
            innerRef={formRef}
            initialValues={inititalValue}
            enableReinitialize
            validationSchema={validateSchema}
          >
            {({
              values,
              errors,
              touched,
              setFieldValue,
              handleSubmit,
              resetForm,
              handleChange,
              ...propsForm
            }) => (
              <Form onSubmit={handleSubmit}>
                <Grid item container spacing={1}>
                  <Grid item xs={12}>
                    <FastField name="tenThuoc">
                      {({ field }) => (
                        <MyTextField
                          required
                          label="Tên thuốc:"
                          placeholder="Nhập..."
                          errors={errors?.tenThuoc}
                          helperText={errors?.tenThuoc}
                          {...field}
                        />
                      )}
                    </FastField>
                  </Grid>
                  <Grid item xs={12}>
                    <FastField name="tacDung">
                      {({ field }) => (
                        <MyTextField
                          label="Tác dụng:"
                          placeholder="Nhập..."
                          {...field}
                        />
                      )}
                    </FastField>
                  </Grid>
                  <Grid item xs={12}>
                    <FastField name="cachDung">
                      {({ field }) => (
                        <MyTextFieldArea
                          label="Cách dùng:"
                          placeholder="Nhập..."
                          maxRows={3}
                          {...field}
                        />
                      )}
                    </FastField>
                  </Grid>
                  <Grid item xs={12}>
                    <FastField name="ghiChu">
                      {({ field }) => (
                        <MyTextFieldArea
                          label="Ghi chú:"
                          placeholder="Nhập..."
                          maxRows={3}
                          {...field}
                        />
                      )}
                    </FastField>
                  </Grid>
                  <Grid item xs={12} className="fileGiayChungNhan">
                    <UploadMultiFile
                      multi={true}
                      title="Tệp đính kèm:"
                      file={values?.hinhAnhs || []}
                      handleChangeFile={values =>
                        setFieldValue(`hinhAnhs`, values)
                      }
                      checkSave={false}
                    />
                  </Grid>
                </Grid>
                <Grid container gap={1} mt={2} justifyContent={"flex-end"}>
                  <MyButton
                    txt={"Đóng"}
                    onClick={() => handleClose(false)}
                    variant="outlined"
                    style={{ width: 120 }}
                    icon={<Close />}
                  />
                  <MyButton
                    txt={
                      typeof open === "boolean" && open
                        ? "Thêm mới"
                        : "Cập nhật"
                    }
                    type="submit"
                    style={{ width: 120 }}
                    icon={<Save />}
                  />
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Box>
    </Modal>
  );
}
